import { Component, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SalesEntityService } from 'app/layout/sales-entity/sales-entity-service/sales-entity-service';
import { BindingContext } from 'app/shared/models/BindingContext';
import { SalesEntityModelList, SalesEntityListInquiry, SystemModel, Institution, SalesRep, Chain, SalesEntityModel, AlliancePartner, Association, SalesEntityBoardingHierarchyNew, SalesEntityContact, SalesEntityAddress, ChangeContext } from 'app/shared/models/EvoSalesPortalModel';
import { HttpErrorResponse } from '@angular/common/http';
import { SubscriptionLike as ISubscription } from 'rxjs';
import { ApprovalsService } from 'app/shared/services/approvals.service';



@Component({
    selector: 'pending-detail-log-modal',
    styleUrls: ['pending-detail-log.component.scss'],
    templateUrl: 'pending-detail-log.component.html',
})
export class PendingDetailLogModalComponent {
    public bindingContext: BindingContext = new BindingContext();
    dataCollection: Array<ChangeContext> = new Array<ChangeContext>();
    @Input() changeID: number;
    @Input() changeAction: string = "";
    public action: string = ""
    constructor(public activeModal: NgbActiveModal,
        private appSvc: ApprovalsService) {
        this.bindingContext.isBusy = false;

    }

    ngOnInit() {
        //Inputs are loaded at this lifecycle event
        this.getChangeContext();
        console.log("changeaction:" ,this.changeAction, this.action);
        if (this.changeAction === "A") { this.action = "Add"; }
        if (this.changeAction === "D") { this.action = "Delete"; }
        if (this.changeAction === "U") { this.action = "Update"; }
    }

    getChangeContext() {
        this.bindingContext.beginGet();
        this.appSvc.GetChangeContext(this.changeID).then(resp => {
            this.bindingContext.endGet(true);
            this.dataCollection = resp;
        }).catch(resp => {
            this.bindingContext.setError(resp);
            this.bindingContext.endGet(false);
        });
    }
    ngOnDestroy() {

    }
}
